import { Link } from 'react-router-dom';
import { tournamentStats } from '@/mocks/home';

export default function QuickLinks() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {tournamentStats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center p-6 bg-background-50 rounded-xl border border-background-200/70 transition-all duration-300 hover:border-primary-300/50"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className={`${stat.icon} text-lg`}></i>
              </span>
              <span className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                {stat.value}
                <span className="text-base font-normal text-foreground-500 ml-0.5">
                  {stat.suffix}
                </span>
              </span>
              <span className="text-xs text-foreground-500 mt-1">{stat.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-5 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-accent-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-live-line mr-1.5"></i>
            观看直播
          </Link>
          <Link
            to="/category/all"
            className="px-5 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line mr-1.5"></i>
            完整赛程
          </Link>
          <a
            href="http://cefotiam.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-vip-crown-line mr-1.5"></i>
            投注入口
          </a>
        </div>
      </div>
    </section>
  );
}